"use client";
import { useQuery } from "@apollo/client/react";

import { gql } from "graphql-tag";
import { ResumableSchoolEnrollmentsDocument } from "./generated";
import { useAuthenticatedContext } from "./AuthenticatedContext";

void gql`
  query resumableSchoolEnrollments($customerId: ID!) {
    resumableSchoolEnrollments(customerId: $customerId) {
      id
      updatedAt
      program {
        id
        name
        slug
        vocationId
        vocation {
          id
          adjective
        }
      }
      provider {
        id
        fullName
        slug
        logoImageFile {
          id
          url
        }
      }
    }
  }
`;

export const useResumableSchoolEnrollments = ({ skip = false }: { skip?: boolean } = {}) => {
  const { customerId } = useAuthenticatedContext();
  const query = useQuery(ResumableSchoolEnrollmentsDocument, {
    variables: { customerId: customerId! },
    skip: skip || !customerId,
  });

  return {
    ...query,
    enrollments:
      skip || !customerId || query.error ? undefined : query.data?.resumableSchoolEnrollments,
  };
};
